import { render, staticRenderFns } from "./bookNowBanner.vue?vue&type=template&id=ba986e30&scoped=true"
import script from "./bookNowBanner.vue?vue&type=script&lang=js"
export * from "./bookNowBanner.vue?vue&type=script&lang=js"
import style0 from "./bookNowBanner.vue?vue&type=style&index=0&id=ba986e30&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba986e30",
  null
  
)

export default component.exports